import { useContext, useEffect, useRef, useState } from 'react';
import { createPortal } from 'react-dom';
import { useNavigate } from 'react-router-dom';
import { useReactToPrint } from 'react-to-print';
import medalGuia from "../../../assets/medal-guia.svg";
import { getResults } from '../../../services/mentoriaService';
import Loader from '../../../shared/src/components/atoms/loader/loader';
import MedalModal from '../../../shared/src/components/organisms/medal-modal/MedalModal';
import authContext from '../../../shared/src/contexts/authContext';
import Button from '../../atoms/button/button';
import ResultCard from '../../molecules/result-card/resultCard';
import DiagnosticoResultPdf from '../diagnostico-result-pdf/diagnosticoResultPdf';
import ScoreBar from '../resultados/score-bar/scoreBar';
import './diagnosticoResult.scss';

const DiagnosticoResult = () => {

	const context = useContext(authContext);
	const [results, setResults] = useState<any>(null);
	const navigate = useNavigate();
	const pdfRef = useRef(null);

	const handlePrint = useReactToPrint({
		content: () => pdfRef.current,
	});

	const getResultsData = async () => {
		if (authContext) {
			const resultsRes = await getResults();

			if (resultsRes.data.status === 500) {
				navigate('/');
				return
			}

			setResults(resultsRes.data.data)
		}
	}

	useEffect(() => {
		if (!context.loading && context.isLoggedIn)
			getResultsData();
	}, [context])

	if (!results || context.loading) {
		return (
			<Loader />
	)
	}

	return (
		<>
			{createPortal(
				<MedalModal>
					<MedalModal.Icon element={<img className="medal-modal__icon" src={medalGuia} alt="Medalla Guia" />} />
					<MedalModal.Title>¡Felicidades!</MedalModal.Title>
					<p><b>¡Desbloqueaste la medalla Guía financiero!</b></p>
					<p>Ahora que eres consciente de tus actitudes, conocimientos, comportamientos y hábitos, estás listo para guiar el camino de tus finanzas.</p>
				</MedalModal>,
				document.body
			)}
			<div style={{ display: 'none' }}>
				<DiagnosticoResultPdf results={results} ref={pdfRef} />
			</div>
			<div className="diagnostico-result">
				<header className="diagnostico-result__header">
					<img src={results.financialHealth.urlImage} alt="Imagen Propósito" />
					<div>
						<h1>Tu resultado</h1>
						<p>Con la información que nos suministraste en la encuesta de diagnóstico financiero, realizaremos el análisis de tus finanzas y queremos entregarte este resultado que te permitirá encontrar oportunidades para continuar creciendo y avanzando hacia tus propósitos.</p>
					</div>
				</header>
				<section className="diagnostico-result__score">
					<div className="background-color"></div>
					<div className="diagnostico-result__score__info">
						<h2>Tu indicador de salud y educación financiera nos dice que:</h2>
						<h3>{results.financialHealth.title}</h3>
						<p>{results.financialHealth.challengeDescription}</p>
					</div>
					<div className="mentoria-resultados__body__results-card">
						<div className="mentoria-resultados__body__results-card__content">
							<header className="mentoria-resultados__body__results-card__content__header">
								<h2 className="mentoria-resultados__body__results-card__content__header__number">
									{results?.totalScore || 0}
								</h2>
								<div className="mentoria-resultados__body__results-card__content__header__description">
									<h4 className="mentoria-resultados__body__results-card__content__header__description__title">
										Tu puntaje
									</h4>
									<p className="mentoria-resultados__body__results-card__content__header__description__subtitle">
										Puntaje máximo 100
									</p>
								</div>
							</header>
							<body className="mentoria-resultados__body__results-card__content__body">
								{results?.score?.map((score) => {
									return (
										<ScoreBar
											key={score.name}
											title={score.name}
											color={score.color || '#1AA8A2'}
											score={score.value}
											toolTipHelp={score.description}
										/>
									);
								})}
							</body>
						</div>
					</div>
				</section>
				<section className="diagnostico-result__indicators">
					<div>
						<h2>Indicadores</h2>
						<p>Este indicador se compone 4 variables que te mostrarán en donde tienes oportunidades de mejora.</p>
					</div>
					<div className="diagnostico-result__indicators__cards">
						{results?.indicators &&
							results.indicators.map((indicator, idx) => {

								let calculatedScore;

								if (indicator.value < 50) {
									calculatedScore = 'bad';
								} else if (indicator.value < 80) {
									calculatedScore = 'medium';
								} else {
									calculatedScore = 'good';
								}

								return <ResultCard title={indicator.name} description={indicator.description} score={calculatedScore}></ResultCard>
							})
						}
					</div>
				</section>
				<div className="diagnostico-result__button-container">
					<Button text="Conoce tu ruta personalizada" gtmClass='secondary' onClick={() => { window.location.replace(process.env.REACT_APP_REDIRECT_URL + '/ruta') }} />
					<Button text="Descarga tu resultado en PDF" onClick={handlePrint} className="download-pdf-button"></Button>
				</div>
			</div>
		</>
	)
}

export default DiagnosticoResult